import { useEffect, useState } from "react";
import { DollarSign, RotateCcw, TrendingUp, CalendarDays, Users, XCircle, Download } from "lucide-react";
import api, { API } from "@/lib/api";

const card = "bg-white dark:bg-neutral-900 border border-brand-line dark:border-neutral-800 rounded-2xl";

export default function Reports() {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/admin/reports").then((x) => setR(x.data)).catch(() => {}); }, []);

  const Stat = ({ label, value, icon: Icon }) => (
    <div className={`${card} p-5`} data-testid={`report-stat-${label.toLowerCase().split(" ")[0]}`}>
      <div className="flex items-center justify-between"><span className="text-xs uppercase tracking-[0.15em] text-brand-ink/50 dark:text-white/40">{label}</span><Icon className="w-5 h-5 text-brand-red" /></div>
      <div className="mt-3 font-display text-3xl">{value}</div>
    </div>
  );

  return (
    <div data-testid="reports-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div><h1 className="font-display text-4xl">Reports</h1><p className="text-brand-ink/60 dark:text-white/50 mt-2">Revenue, attendance and popularity at a glance.</p></div>
        <div className="flex gap-3">
          <a href={`${API}/admin/bookings/export.csv`} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-brand-line dark:border-neutral-700 text-sm hover:border-brand-red transition-colors" data-testid="export-bookings-csv"><Download className="w-4 h-4" /> Bookings CSV</a>
          <a href={`${API}/admin/payments/export.csv`} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-brand-line dark:border-neutral-700 text-sm hover:border-brand-red transition-colors" data-testid="export-payments-csv"><Download className="w-4 h-4" /> Payments CSV</a>
        </div>
      </div>
      <div className="mt-8 grid gap-4 sm:grid-cols-3 lg:grid-cols-6">
        <Stat label="Gross Revenue" value={`$${(r?.gross || 0).toFixed(2)}`} icon={DollarSign} />
        <Stat label="Refunded" value={`$${(r?.refunded || 0).toFixed(2)}`} icon={RotateCcw} />
        <Stat label="Net Revenue" value={`$${(r?.net || 0).toFixed(2)}`} icon={TrendingUp} />
        <Stat label="Bookings" value={r?.bookings || 0} icon={CalendarDays} />
        <Stat label="Customers" value={r?.customers || 0} icon={Users} />
        <Stat label="Cancellations" value={r?.cancellations || 0} icon={XCircle} />
      </div>
      <div className="mt-6 grid md:grid-cols-2 gap-6">
        <div className={`${card} p-6`} data-testid="popular-classes">
          <h2 className="font-display text-xl mb-4">Most popular classes</h2>
          {(r?.popular_classes || []).length === 0 ? <p className="text-brand-ink/50 dark:text-white/40 text-sm">No data yet.</p> : (r?.popular_classes || []).map((c, i) => (
            <div key={i} className="flex justify-between py-2 border-b border-brand-line dark:border-neutral-800 last:border-0 text-sm"><span>{c.name}</span><span className="font-semibold">{c.count}</span></div>
          ))}
        </div>
        <div className={`${card} p-6`} data-testid="popular-locations">
          <h2 className="font-display text-xl mb-4">Most popular locations</h2>
          {(r?.popular_locations || []).length === 0 ? <p className="text-brand-ink/50 dark:text-white/40 text-sm">No data yet.</p> : (r?.popular_locations || []).map((c, i) => (
            <div key={i} className="flex justify-between py-2 border-b border-brand-line dark:border-neutral-800 last:border-0 text-sm"><span>{c.name}</span><span className="font-semibold">{c.count}</span></div>
          ))}
        </div>
      </div>
    </div>
  );
}
